import type { PopoverProps } from '@carboncopyco/ui';
import { Popover } from '@carboncopyco/ui';
import type React from 'react';
import { RuleOptionButton } from './RuleOptionButton';

export interface RuleSelectionOption<T extends string> {
  value: T;
  icon: React.ReactElement;
  label: string;
}

export interface RuleSelectionPopoverProps<T extends string>
  extends Pick<PopoverProps, 'triggerElement' | 'open' | 'onOpenChange'> {
  options: RuleSelectionOption<T>[];
  onSelect: (value: T) => void;
}

export const RuleSelectionPopover = <T extends string>({
  triggerElement,
  open,
  options,
  onOpenChange,
  onSelect,
}: RuleSelectionPopoverProps<T>) => {
  return (
    <Popover
      asChild
      triggerElement={triggerElement}
      aria-label="Rule selection"
      align="end"
      open={open}
      onOpenChange={onOpenChange}
    >
      <div className="p-2.5 flex gap-2.5">
        {options.map(({ label, icon, value }) => (
          <RuleOptionButton
            key={value}
            label={label}
            icon={icon}
            onClick={() => onSelect(value)}
          />
        ))}
      </div>
    </Popover>
  );
};
